

































import { Vue, Component } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';

@Component({
  components: { PagingUnit, CollapseTransition },
  mixins: [TableStripe],
})
export default class DeviceManagement extends Vue {
  private searchForm: any = {};
  private tableData: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;

  created() {
    this.getData();
  }
  private getData() {
    const obj: any = {};
    for (const key in this.searchForm) {
      if ((this.searchForm as any)[key]) {
        // 如果搜索表单里面的这一项有值，那么就加入到 分页搜索数据中
        obj[key] = (this.searchForm as any)[key];
      }
    }
  }

  private getListData() {
    this.getData();
  }

  mounted() {}
}
